export enum ROLES {
	ADMINISTRADOR = 'ADMINISTRADOR',
	MONITOR = 'MONITOR',
}
